import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductListItemEntityParams {
  quick_order_list_id: string;
  quick_order_list_product_id: string;
  product_id: string;
  product_line_id: string;
}
export class ProductListItemEntity extends BaseEntityClass {
  quick_order_list_id: string;
  quick_order_list_product_id: string;
  product_id: string;
  product_line_id: string;

  constructor(params: ProductListItemEntityParams) {
    super();
    this.type = "product_list_item";
    this.entity_version = 3;
    this.quick_order_list_id = params.quick_order_list_id;
    this.quick_order_list_product_id = params.quick_order_list_product_id;
    this.product_id = params.product_id;
    this.product_line_id = params.product_line_id;
  }
}
